import React, { useState } from 'react';
import {
  PaymentElement,
  LinkAuthenticationElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

const StripePaymentForm: React.FC<{ price: number }> = ({ price }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [name, setName] = useState('');
  const [selectedMethod, setSelectedMethod] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable form submission until it has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/mesa-de-regalos?gift=true`,
        payment_method_data: {
          billing_details: { name }, // Collect and send the name
        },
      },
    });

    if (error) {
      setMessage(error.message || 'Ha ocurrido un error');
    } else {
      setMessage('Pago procesado correctamente.');
    }

    setIsLoading(false);
  };

  const handleElementChange = (event: any) => {
    // Check for selected payment method
    if (event?.value?.type) {
      setSelectedMethod(event.value.type);
    }
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit} className="space-y-6">
      {/* Email Link Authentication */}
      <PaymentElement
        id="payment-element"
        options={{
          layout: 'tabs',
          defaultValues: {},
          fields: {
            billingDetails: { name: 'auto' },
          },
          wallets: { applePay: 'auto', googlePay: 'auto' },
        }}
        onChange={handleElementChange}
        onReady={() => setIsReady(true)}
      />
      {isReady && selectedMethod === 'card' && (
        <div className="mb-4 mt-[0.75rem!important]">
          <label
            htmlFor="name"
            className="block text-sm mb-2 text-left color-[#30313D]"
            style={{
              fontFamily: `-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif`,
            }}
          >
            Full name
          </label>
          <input
            id="name"
            type="text"
            placeholder="First and last name"
            className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 "
            required
          />
        </div>
      )}
      {isReady && (
        <button
          disabled={isLoading || !stripe || !elements}
          id="submit"
          className="w-full px-6 py-3 bg-[#B94665] text-white text-sm font-semibold rounded-lg hover:bg-[#9c3b57] transition-colors"
        >
          <span id="button-text">
            {isLoading || !stripe || !elements ? (
              <div className="spinner border-t-2 border-b-2 border-white rounded-full h-5 w-5 animate-spin"></div>
            ) : (
              `Pagar ${price.toLocaleString('es-MX')} MXN`
            )}
          </span>
        </button>
      )}

      {/* Error or Success Message */}
      {message && (
        <div id="payment-message" className="text-red-500 text-center">
          {message}
        </div>
      )}
    </form>
  );
};

export default StripePaymentForm;
